export enum BidStatus {
  BID_SUBMITTED = 'BID_SUBMITTED',

  BID_ACCEPTED = 'BID_ACCEPTED',

  BID_REJECTED = 'BID_REJECTED',

  BID_CANCELLED = 'BID_CANCELLED',

  BID_FULFILLED = 'BID_FULFILLED',

  BID_UNFULFILLED = 'BID_UNFULFILLED',
}
